"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderById = exports.getAppointmentById = void 0;
/**
 * Function to call the `getAppointment` callback, extract the data from it,
 * and return the converted form for use in the state machine.
 * @param {*} getAppointmentCallback Callback to make an API request to get an appointment.
 *                                   Returns the HTTP Response.
 *                                   Appointment data will be nested under `data` in `appointment` and `capabilities`.
 * @param {*} appointmentId The id of the appointment we're requesting.
 * @returns {object} The converted appointment object to be stored in the machine context.
 */
const getAppointmentById = (getAppointmentCallback, appointmentId) => __awaiter(void 0, void 0, void 0, function* () {
    const appointmentResponse = yield getAppointmentCallback(appointmentId);
    return appointmentResponse.data;
});
exports.getAppointmentById = getAppointmentById;
const getProviderById = (getProviderCallback, providerId) => __awaiter(void 0, void 0, void 0, function* () {
    const providerResponse = yield getProviderCallback(providerId);
    const provider = Object.assign(Object.assign({}, providerResponse.data.data.provider), { locations: providerResponse.data.data.locations });
    return provider;
});
exports.getProviderById = getProviderById;
//# sourceMappingURL=API.js.map